import {
  apiRoutes,
  type DefaultQueryError,
  httpClient,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { ProgressesSubscriptionDetail } from './types';

export interface CancelAutoRenewReq {
  progresses_id: ProgressesSubscriptionDetail['_id'];
}

export interface CancelAutoRenewRes {
  status: string;
}

export const cancelAutoRenewFn = async ({
  progresses_id,
}: CancelAutoRenewReq) => {
  const res = await httpClient.put<CancelAutoRenewRes>(
    apiRoutes.subscription.progresses_subscription_detail(progresses_id)
  );

  return res.data;
};

export const useCancelAutoRenew = (
  opts?: UseMutationOptions<
    CancelAutoRenewRes,
    DefaultQueryError,
    CancelAutoRenewReq
  >
) =>
  useMutation<CancelAutoRenewRes, DefaultQueryError, CancelAutoRenewReq>({
    mutationFn: cancelAutoRenewFn,
    ...opts,
  });
